import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModalViewControlService {
  private readonly STORAGE_KEY = 'lastInactiveClaimModalView';
  private readonly ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000; // 7 dias em milissegundos

  constructor() {}

  /**
   * Verifica se o modal pode ser exibido
   * @returns true se pode exibir (não foi visto ou passou mais de 1 semana)
   */
  canShowModal(): boolean {
    const lastView = this.getLastViewTimestamp();
    
    if (!lastView) {
      return true; // Nunca foi visto
    }

    const now = Date.now();
    const timeSinceLastView = now - lastView;

    return timeSinceLastView >= this.ONE_WEEK_MS;
  }

  /**
   * Marca o modal como visto agora
   */
  markModalAsViewed(): void {
    localStorage.setItem(this.STORAGE_KEY, Date.now().toString());
  }

  /**
   * Obtém o timestamp da última visualização
   * @returns timestamp ou null se nunca foi visto
   */
  private getLastViewTimestamp(): number | null {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    
    if (!stored) {
      return null;
    }

    const timestamp = parseInt(stored, 10);
    
    if (isNaN(timestamp)) {
      return null;
    }

    return timestamp;
  }

  /**
   * Limpa o histórico de visualização (útil para testes)
   */
  clearViewHistory(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  /**
   * Obtém informações sobre a última visualização
   */
  getViewInfo(): { lastViewed: Date | null; canShow: boolean } {
    const timestamp = this.getLastViewTimestamp();
    
    return {
      lastViewed: timestamp ? new Date(timestamp) : null,
      canShow: this.canShowModal(),
    };
  }
}
